import React, { ReactNode } from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTheme as useCustomTheme } from '../context/ThemeContext';

interface PageLayoutProps {
  children: ReactNode;
  containerWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  withoutGradient?: boolean;
}

/**
 * Composant de mise en page qui applique le thème global et le fond dégradé.
 * Utilisez ce composant comme wrapper pour vos pages.
 */
const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  containerWidth = 'lg',
  withoutGradient = false
}) => {
  const theme = useTheme();
  const { activeThemeDefinition } = useCustomTheme();

  // URL du filigrane : uniquement si défini et activé dans le thème
  const watermarkUrl = activeThemeDefinition?.assets?.watermarkEnabled && activeThemeDefinition?.assets?.watermark?.url;

  return (
    <>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'transparent',
          color: theme.palette.text.primary,
          pt: 2,
          pb: 4,
          position: 'relative',
          ...(watermarkUrl ? {
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url("${watermarkUrl}")`,
              backgroundPosition: 'center',
              backgroundSize: '400px auto',
              backgroundRepeat: 'repeat',
              backgroundAttachment: 'scroll',
              opacity: 0.05,
              pointerEvents: 'none',
              zIndex: 0
            }
          } : {
            '&::before': { display: 'none' }
          })
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          {containerWidth ? (
            <Container maxWidth={containerWidth}>
              {children}
            </Container>
          ) : (
            children
          )}
        </Box>
      </Box>
    </>
  );
};

export default PageLayout;
